import { createContext, useContext } from 'react'

export interface AuthUser {
  sub: string
  name?: string
  email?: string
  workspaceId?: string
  projectId?: string
  worldId?: string
  avatarId?: string
  roles?: string[]
  /** Non-secret authenticated-session partition for reload-safe browser state. */
  sessionBinding?: string
  [key: string]: unknown
}

export type AuthStatus = 'loading' | 'unauthenticated' | 'authenticated' | 'error'

export interface AuthState {
  status: AuthStatus
  user: AuthUser | null
  /** Legacy provider compatibility; server sessions never expose this token. */
  accessToken: string | null
  error: string | null
  login: () => Promise<void>
  logout: () => void | Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuthContext(): AuthState {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuthContext must be used within an auth provider')
  return context
}
